import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  position: relative;
`;

export const Gallery = styled.div`
  width: 400px;
  height: ${({ $hasThumbs }) => ($hasThumbs ? '500px' : '380px')};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
